import { render, staticRenderFns } from "./LockerFeatures.vue?vue&type=template&id=3ed7d8e4&"
import script from "./LockerFeatures.vue?vue&type=script&lang=ts&"
export * from "./LockerFeatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports